/****************************************************
 * Module Name:  CreateMapping.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/

import React, { useState, useEffect, useMemo } from "react";
import renderCellExpand from "../common/dataGridCellExpand";
import { Autocomplete, Box, Tooltip, TextField, IconButton, Button } from "@mui/material";
import CommonSnackbar from "../common/commonSnackBar";
import Constants from "../../utility/constants";
import { DataGridPro, GridToolbarExport, GridToolbarColumnsButton, GridToolbarContainer, GridToolbarFilterButton, GridToolbarQuickFilter } from "@mui/x-data-grid-pro";
import CircularProgress from "@mui/material/CircularProgress";
import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";
import ConsigneeMasterProxy from "../../utility/proxy/nivodautility/consigneeMasterProxy";
import EditIcon from '@mui/icons-material/Edit';
import NoPermission from "../common/noPermission";
import UserProxy from "../../utility/proxy/manager/userProxy";
import WolzaIndiaExportProxy from "../../utility/proxy/nivodautility/wolzaIndiaExportProxy";
import EmployeeCustomerProxy from "../../utility/proxy/manager/employeeCustomerProxy";
import { SvgIcon } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import Utility from "../../utility/utility";
import StoneProxy from "../../utility/proxy/manager/stoneProxy";
import CutProxy from "../../utility/proxy/manager/cutProxy";
import PolProxy from "../../utility/proxy/manager/polProxy";
import SymProxy from "../../utility/proxy/manager/symProxy";
import FloProxy from "../../utility/proxy/manager/floProxy";
import ClarityProxy from "../../utility/proxy/manager/clarityProxy";
import ColorProxy from "../../utility/proxy/manager/colorProxy";
import SizeProxy from "../../utility/proxy/manager/sizeProxy";
import ShapeProxy from "../../utility/proxy/manager/shapeProxy";
import LabProxy from "../../utility/proxy/manager/labProxy";
import LocationProxy from "../../utility/proxy/manager/locationProxy";
import FileCopyRoundedIcon from "@mui/icons-material/FileCopyRounded";
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import TabMenuSnackbar from "../common/tabMenuSnackbar";
import MarketSellWolzaModal from "../common/marketSellWolzaModal";
import { Modal } from "react-bootstrap";
import logo from '../../images/pansuriya.jpg'
import SettingsProxy from "../../utility/proxy/manager/settingsProxy";
import PageTitle from "../common/pageTitle";


const CreateMapping = () => {
    const [errorSnackbar, setErrorSnackbar] = useState(false);
    const [consigneeList, setConsigneeList] = useState([]);
    const [consigneeListLoader, setConsigneeListLoader] = useState(true);
    const [userOptions, setUserOptions] = useState([]);
    const [companyOptions, setCompanyOptions] = useState([]);
    const [companyMap, setCompanyMap] = useState([]);
    const [userMap, setUserMap] = useState([]);
    const [access, setAccess] = useState(false);
    const [companyInputValue, setCompanyInputValue] = useState('');
    const [userInputValue, setUserInputValue] = useState('');
    const [selectionModel, setSelectionModel] = useState([]);
    const [open, setOpen] = useState(false);
    const [companyRefresh, setCompanyRefresh] = useState(undefined);
    const [userRefresh, setUserRefresh] = useState(undefined);
    const [filterValues, setFilterValues] = useState({});

    const [wolzaCriteria, setWolzaCriteria] = useState(Utility.getDefaultCriteriaToGenerateLink);
    const [labOptions, setLabOptions] = useState([]);
    const [locationOptions, setLocationOptions] = useState([]);
    const [cutOptions, setCutOptions] = useState([]);
    const [polOptions, setPolOptions] = useState([]);
    const [symOption, setSymOptions] = useState([]);
    const [floOption, setFloOptions] = useState([]);
    const [clarityOptions, setClarityOptions] = useState([]);
    const [colorOptions, setColorOptions] = useState([]);
    const [sizeOptions, setSizeOptions] = useState([]);
    const [shapeOptions, setShapeOptions] = useState([]);
    const [showSnackbar, setShowSnackbar] = useState(false);
    const [snackBarTitle, setSnackBarTitle] = useState("");
    const [snackBarMessage, setSnackBarMessage] = useState("");
    const [snackBarVariant, setSnackBarVariant] = useState("");
    const [showWolzaDetailModal, setShowWolzaDetailModal] = useState(false);
    const [slectedCustomer, setSelectedCustomer] = useState({ customer: [] });
    const [stonetype, setStonetype] = useState("");

    useEffect(() => {
        PageTitle("ANALYSIS_WOLZA_MAPCONSIGNEE_CREATE");
        LabProxy.GetAllLabMini((response) => {
            let lLabOption = [];
            response.map((data) => lLabOption.push({ value: data.name, label: data.name, selected: false }))
            setLabOptions(lLabOption);
        });

        LocationProxy.GetAllLocationDetailMini((response) => {
            let lLocationOption = [];
            response.map((data) => lLocationOption.push({ value: data.id, label: data.name, selected: false }));
            setLocationOptions(lLocationOption);
        });

        CutProxy.GetAllCutMini((response) => {
            let lCutOption = [];
            response.map((data) => lCutOption.push({ value: data.name, label: data.name, selected: false }));
            setCutOptions(lCutOption);
        });

        PolProxy.GetAllPolMini((response) => {
            let lPolOption = [];
            response.map((data) => lPolOption.push({ value: data.name, label: data.name, selected: false }));
            setPolOptions(lPolOption);
        });

        SymProxy.GetAllSymMini((response) => {
            let lSymOption = [];
            response.map((data) => lSymOption.push({ value: data.name, label: data.name, selected: false }));
            setSymOptions(lSymOption);
        });

        FloProxy.GetAllFloMini((response) => {
            let lFloOption = [];
            response.map((data) => lFloOption.push({ value: data.name, label: data.name, selected: false }));
            setFloOptions(lFloOption);
        });

        ClarityProxy.GetAllClarityMini((response) => {
            let lClarityOption = [];
            response.map((data) => lClarityOption.push({ value: data.name, label: data.name, selected: false }));
            setClarityOptions(lClarityOption);
        });

        ColorProxy.GetAllColorMini((response) => {
            let lColorOption = [];
            response.map((data) => lColorOption.push({ value: data.name, label: data.name, selected: false }));
            setColorOptions(lColorOption);
        });

        SizeProxy.GetAllSizeMini((response) => {
            let lWeightOption = [];
            response.map((iWeight) => lWeightOption.push({ value: iWeight.id, label: iWeight.name, selected: false }));
            setSizeOptions(lWeightOption);
        });

        ShapeProxy.GetAllShapeMini((response) => {
            let res = response.filter((iShape) => iShape.disabled === false);

            let lShapeOption = [];
            res.map((iShape) => lShapeOption.push({ value: iShape.id, label: iShape.name, selected: false, image: iShape.image }));

            setShapeOptions(lShapeOption);
        });
    }, []);

    useEffect(() => {
        let searchCriteria = wolzaCriteria;
        searchCriteria.labOption = labOptions;
        searchCriteria.locationOption = locationOptions;
        searchCriteria.cutOption = cutOptions;
        searchCriteria.polOption = polOptions;
        searchCriteria.symOption = symOption;
        searchCriteria.floOption = floOption;
        searchCriteria.shapeOption = shapeOptions;
        searchCriteria.colorOption = colorOptions;
        searchCriteria.clarityOption = clarityOptions;
        searchCriteria.weightOption = sizeOptions;

        setWolzaCriteria(searchCriteria);
    }, [labOptions, locationOptions, cutOptions, polOptions, symOption, floOption, sizeOptions, shapeOptions, colorOptions, clarityOptions])


    useEffect(() => {
        checkPermission();
    }, []);


    const checkPermission = () => {
        let allowed = Constants.USER_PERMISSION.find(
            (iPermission) =>
                iPermission.permissionid ===
                Constants.PERMISSIONS.ANALYSIS_WOLZA_MAPCONSIGNEE_CREATE
        ) !== undefined
        if (!allowed) {
            setAccess(true)
            return <NoPermission />
        } else {
            fetchConsigneeData(true);
        }
    }

    const fetchConsigneeData = (bAnimateSpinner) => {
        setConsigneeListLoader(true);
        bAnimateSpinner && setConsigneeListLoader(true);
        ConsigneeMasterProxy.GetAllConsignee(
            false,
            (responseData) => {
                if (responseData) {
                    const uniqueFilterValues = {
                        countryofdestination: Utility.getDistinctOptions(responseData, "countryofdestination"),
                        updatedbyuser: Utility.getDistinctOptions(responseData, "updatedbyuser"),
                        mappedtoemployee: Utility.getDistinctOptions(responseData, "mappedtoemployee"),
                        updatedbycompany: Utility.getDistinctOptions(responseData, "updatedbycompany"),
                    };
                    const combinedFilterValues = {
                        updatedbyuser: uniqueFilterValues.updatedbyuser.map(value => {
                            const matchingItem = responseData.find(item => item.updatedbyuser === value);
                            return matchingItem && matchingItem.updatedbyid ? `${matchingItem.updatedbyid} | ${value}` : '';
                        }),
                        mappedtoemployee: uniqueFilterValues.mappedtoemployee,
                        updatedbycompany: uniqueFilterValues.updatedbycompany,
                        countryofdestination: uniqueFilterValues.countryofdestination,
                    }
                    setFilterValues(combinedFilterValues);

                    // Sort responseData by consigneename (A-Z and then numbers) as discussed with ajay 
                    responseData.sort((a, b) => {
                        const nameA = a.consigneename || "";
                        const nameB = b.consigneename || "";

                        const isAlphaA = /^[a-zA-Z]/.test(nameA);
                        const isAlphaB = /^[a-zA-Z]/.test(nameB);

                        if (isAlphaA && !isAlphaB) return -1;
                        if (!isAlphaA && isAlphaB) return 1;
                        return nameA.localeCompare(nameB);
                    });

                    let newListData = [];
                    responseData.forEach((res) => {
                        let listOp = {
                            ...res,
                            link: "",
                        }
                        newListData.push(listOp);
                        return true;
                    })
                    setConsigneeList(newListData);
                    getAllMappedUserData(true);
                    setConsigneeListLoader(false);
                } else {
                    setErrorSnackbar(true);
                    setConsigneeListLoader(false);
                }
            }
        );
    };

    const getAllMappedUserData = (bAnimateSpinner) => {
        UserProxy.getAllCustomerMappedEmployeeMini((response) => {
            if (response)
                setAllMappedUserData(response)
            else {
                setErrorSnackbar(true);
            }
        });
    };

    const setAllMappedUserData = (res) => {
        if (res) {
            let companyOptionsArray = [];
            let userOptionsArray = [];
            let idToCompanyMap = {};
            let idToUserMap = {};
            res.sort((a, b) => a.mappedtocompany.toLowerCase().localeCompare(b.mappedtocompany.toLowerCase())).forEach(data => {
                if (data.mappedtoid && data.mappedtocompany) {
                    let companyLabel = `${data.mappedtoid} | ${data.mappedtocompany}`;
                    if (data.mappedtoemployee) {
                        companyLabel += ` | ${data.mappedtoemployee}`;
                    }
                    let companyOption = {
                        value: data.mappedtocompany,
                        label: companyLabel
                    };
                    companyOptionsArray.push(companyOption);
                    idToCompanyMap[data.mappedtoid] = [data.mappedtocompany, data.mappedtoemployeeid, data.mappedtoemployee];
                }
            });
            res.sort((a, b) => a.mappedtouser.toLowerCase().localeCompare(b.mappedtouser.toLowerCase())).forEach(data => {
                if (data.mappedtoid && data.mappedtouser) {
                    let userLabel = `${data.mappedtoid} | ${data.mappedtouser}`;
                    if (data.mappedtoemployee) {
                        userLabel += ` | ${data.mappedtoemployee}`;
                    }
                    let userOption = {
                        value: data.mappedtouser,
                        label: userLabel
                    };
                    userOptionsArray.push(userOption);
                    idToUserMap[data.mappedtoid] = [data.mappedtouser, data.mappedtoemployeeid, data.mappedtoemployee];
                }
            });
            setCompanyOptions(companyOptionsArray);
            setUserOptions(userOptionsArray);
            setCompanyMap(idToCompanyMap);
            setUserMap(idToUserMap);
        }
    }

    const updateConsignee = (consigneeData) => {
        ConsigneeMasterProxy.UpdateConsignee(consigneeData, (response) => {
            if (response) {
            } else {
                setErrorSnackbar(true);
            }
        });
    }

    const filteredUserOptions = useMemo(() => {
        let options = userOptions.filter(option =>
            option.label.toLowerCase().includes(userInputValue.toLowerCase())
        );
        return [...options.slice(0, 100)];
    }, [userInputValue, userOptions]);

    const filteredCompanyOptions = useMemo(() => {
        let options = companyOptions.filter(option =>
            option.label.toLowerCase().includes(companyInputValue.toLowerCase())
        );
        return [...options.slice(0, 10)];
    }, [companyInputValue, companyOptions]);


    const handleCompanyChange = (event, newValue, consigneeid) => {
        if (newValue) {
            const companyname = newValue.value;
            const userid = newValue.label.split(" | ")[0];
            const companyData = companyMap[userid];
            const username = userMap[userid] ? userMap[userid][0] : '';
            const employeeid = companyData ? companyData[1] : '';
            const employeeName = companyData ? companyData[2] : '';

            let updatedListData;

            // If the consigneeid is in the selectionModel, update all selected rows
            if (selectionModel.includes(consigneeid)) {
                updatedListData = consigneeList.map(row => {
                    if (selectionModel.includes(row.consigneeid)) {
                        return {
                            ...row,
                            company: companyname,
                            mappedtocompany: companyname,
                            mappedtouser: username,
                            mappedtoid: userid,
                            mappedtoemployeeid: employeeid,
                            mappedtoemployee: employeeName,
                        };
                    }
                    return row;
                });
            } else {
                // Otherwise, update only the specific row
                updatedListData = consigneeList.map(row => {
                    if (row.consigneeid === consigneeid) {
                        return {
                            ...row,
                            company: companyname,
                            mappedtocompany: companyname,
                            mappedtouser: username,
                            mappedtoid: userid,
                            mappedtoemployeeid: employeeid,
                            mappedtoemployee: employeeName,
                        };
                    }
                    return row;
                });
            }
            setConsigneeList(updatedListData);
            setUserInputValue('');
            setCompanyInputValue('');

            const rowsToUpdate = selectionModel.includes(consigneeid) ? selectionModel : [consigneeid];
            rowsToUpdate.forEach(rowId => {
                const updatedRow = updatedListData.find(row => row.consigneeid === rowId);
                const data = {
                    id: updatedRow.consigneeid,
                    consigneename: updatedRow.consigneename,
                    countryofdestination: updatedRow.countryofdestination,
                    userid: updatedRow.mappedtoid,
                    updatedby: Constants.loggedInUser.id,
                };
                updateConsignee(data);
                setSelectionModel([]);
            });
        }
    };

    const handleUserChange = (event, newValue, consigneeid) => {
        if (newValue) {
            const username = newValue.value;
            const userid = newValue.label.split(" | ")[0];
            const userData = userMap[userid];
            const companyname = companyMap[userid] ? companyMap[userid][0] : '';
            const employeeid = userData ? userData[1] : '';
            const employeeName = userData ? userData[2] : '';

            let updatedListData;

            // If the consigneeid is in the selectionModel, update all selected rows
            if (selectionModel.includes(consigneeid)) {
                updatedListData = consigneeList.map(row => {
                    if (selectionModel.includes(row.consigneeid)) {
                        return {
                            ...row,
                            user: username,
                            mappedtocompany: companyname,
                            mappedtouser: username,
                            mappedtoid: userid,
                            mappedtoemployeeid: employeeid,
                            mappedtoemployee: employeeName,
                        };
                    }
                    return row;
                });
            } else {
                // Otherwise, update only the specific row
                updatedListData = consigneeList.map(row => {
                    if (row.consigneeid === consigneeid) {
                        return {
                            ...row,
                            user: username,
                            mappedtocompany: companyname,
                            mappedtouser: username,
                            mappedtoid: userid,
                            mappedtoemployeeid: employeeid,
                            mappedtoemployee: employeeName,
                        };
                    }
                    return row;
                });
            }

            setConsigneeList(updatedListData);
            setUserInputValue('');
            setCompanyInputValue('');

            const rowsToUpdate = selectionModel.includes(consigneeid) ? selectionModel : [consigneeid];
            rowsToUpdate.forEach(rowId => {
                const updatedRow = updatedListData.find(row => row.consigneeid === rowId);
                const data = {
                    id: updatedRow.consigneeid,
                    consigneename: updatedRow.consigneename,
                    countryofdestination: updatedRow.countryofdestination,
                    userid: updatedRow.mappedtoid,
                    updatedby: Constants.loggedInUser.id,
                };

                updateConsignee(data);
                setSelectionModel([]);
            });
        }
    };

    const handleButtonClick = (consigneeid, consigneename, source) => {
        handleAddUser(consigneeid, consigneename, source);
    };

    const handleAddUser = (consigneeid, consignee_name, source) => {
        setConsigneeListLoader(true);
        setOpen(false);
        WolzaIndiaExportProxy.GetWolzaDetail(consigneeid, (response) => {
            let user = {};
            if (response) {
                const { consigneename, consigneeadd1, consigneecity } = response;
                user = {
                    companyname: consigneename.trim(),
                    username: consigneename.replace(/\s+/g, '').trim(),
                    first_name: consigneename.replace(/\s+/g, '').trim(),
                    email: null,
                    phone: null,
                    city: consigneecity,
                    address: consigneeadd1,
                    usertype: 'C',
                    createdby: Constants.loggedInUser.username,
                    password: btoa(Constants.newUserPassword),
                    locationid: Constants.DEFAULT_LOCATION_ID,
                };
            }
            else {
                user = {
                    companyname: consignee_name.trim(),
                    username: consignee_name.replace(/\s+/g, '').trim(),
                    first_name: consignee_name.replace(/\s+/g, '').trim(),
                    usertype: 'C',
                    createdby: Constants.loggedInUser.username,
                    password: btoa(Constants.newUserPassword),
                    locationid: Constants.DEFAULT_LOCATION_ID,
                };
            }
            // we need to map this consignee to the employee from settings
            getDefaultEmployeeId(user, consigneeid, source);
        });
    }

    const getDefaultEmployeeId = (user, consigneeid, source) => {
        const settingKey = "MAP_CONSIGNEE_DEFAULT_USERID";
        SettingsProxy.GetSettingByName(settingKey, response => {
            if (response && response.settingvalue && response.settingvalue !== "") {
                createUser(user, consigneeid, source, response.settingvalue);
            } else {
                createUser(user, consigneeid, source, Constants.loggedInUser.id);
            }

        });
    }

    const createUser = (user, consigneeid, source, employeeId) => {
        UserProxy.signUp(user, (response) => {
            if (response) {
                const employeeCustomer = [{
                    employeid: parseInt(employeeId),
                    customerid: response.id
                }];
                mapEmployeeToCustomer(employeeCustomer, consigneeid, response.companyname, response.username, source);
            } else {
                setConsigneeListLoader(false);
                setErrorSnackbar(true);
            }
        });
    }

    const mapEmployeeToCustomer = (employeeCustomer, consigneeid, companyname, username, source) => {
        EmployeeCustomerProxy.createEmployeeCustomer(employeeCustomer, (response) => {
            if (response) {
                fetchConsigneeData(true);
                source === 'company' ? setCompanyRefresh({ consigneeid, companyname }) : setUserRefresh({ consigneeid, username });
            } else {
                setConsigneeListLoader(false);
                setErrorSnackbar(true);
            }
        });
    }

    useEffect(() => {
        if (companyRefresh) {
            const newUserOption = companyOptions.find(option =>
                option.value === companyRefresh.companyname
            );

            if (newUserOption) {
                handleCompanyChange(null, newUserOption, companyRefresh.consigneeid);
                setCompanyInputValue(companyRefresh.companyname);
            }
        }
        setCompanyRefresh(undefined);
    }, [companyOptions])

    useEffect(() => {
        if (userRefresh) {
            const newUserOption = userOptions.find(option =>
                option.value === userRefresh.username
            );

            if (newUserOption) {
                handleUserChange(null, newUserOption, userRefresh.consigneeid);
                setUserInputValue(userRefresh.username);
            }
        }
        setUserRefresh(undefined);
    }, [userOptions])

    const openLinkInNewTab = (link) => {
        window.open(link, '_blank', 'noopener,noreferrer');
    };

    const handleWolzaDetail = (params, stonetype) => {
        setSelectedCustomer({ customer: [{ value: params.row.consigneeid, label: params.row.consigneename }] });
        setStonetype(stonetype);
        setShowWolzaDetailModal(true);
    }

    const generateLink = async (companyData, stoneType) => {
        return new Promise((resolve, reject) => {
            let data = wolzaCriteria;
            data.selectedCustomer = {
                "label": Constants.loggedInUser.companyname,
                "value": Constants.loggedInUser.id,
            };

            let reqData = {
                createdby: Constants.loggedInUser.id,
                customerid: -1,
                consigneeid: companyData.consigneeid,
                criteria: JSON.stringify(JSON.stringify(data)),
                stonetype: stoneType,
            }

            StoneProxy.GenerateCriteriaLinkForWolzaDataStoneIds(Constants.loggedInUser.id, reqData, (response) => {
                if (response) {
                    let link = `${window.location.origin}/app/operation/stock?id=${response.guid}`;
                    let newListData = [];
                    consigneeList.forEach((res) => {
                        if (companyData.consigneeid === res.id) {
                            let listOp = {
                                ...res,
                                link: link,
                            }
                            newListData.push(listOp);
                        } else {
                            newListData.push(res);
                        }
                    });
                    setConsigneeList(newListData);
                    setShowSnackbar(true);
                    setSnackBarMessage("Link generated successfully");
                    setSnackBarVariant("success");
                    resolve(link);  // Resolve the Promise with the generated link
                } else {
                    setShowSnackbar(true);
                    setSnackBarMessage(Constants.APiFailErrorMessage);
                    setSnackBarVariant("error");
                    reject("Failed to generate link");  // Reject the Promise in case of failure
                }
            });
        });
    }

    const initialColumns = () => [
        {
            field: "consigneeid",
            headerName: "CONSIGNEE ID",
            headerAlign: "center",
            align: "center",
            type: "number",
            valueFormatter: (params) => params.value,
            width: 80,
            renderCell: renderCellExpand,
        },
        {
            field: "consigneename",
            headerName: "WOLZA CONSIGNEE NAME",
            headerAlign: "center",
            align: "center",
            width: 250,
            renderCell: renderCellExpand,
        },
        {
            field: "countryofdestination",
            headerName: "COUNTRY OF DESTINATION",
            headerAlign: "center",
            align: "center",
            width: 200,
            type: "singleSelect",
            valueOptions: filterValues ? filterValues.countryofdestination : [],
            filterOperators: Utility.combinedFilters(),
            renderCell: renderCellExpand,
        },
        {
            field: "mappedtoid",
            headerName: "MAPPED TO ID",
            headerAlign: "center",
            align: "center",
            type: "number",
            valueFormatter: (params) => params.value,
            width: 80,
            renderCell: renderCellExpand,
        },
        {
            field: "company",
            headerName: "MAPPED TO COMPANY",
            headerAlign: "center",
            align: "center",
            width: 350,
            editable: true,
            renderCell: (params) => {
                const companyname = params.row.mappedtocompany != null ? params.row.mappedtocompany : '';
                const userid = params.row.mappedtoid ? params.row.mappedtoid : '';
                const companyData = companyMap[userid];
                const employeeid = companyData ? companyData[1] : '';
                const employeeName = companyData ? companyData[2] : '';

                let displayValue = '';

                if (userid && companyname) {
                    displayValue = `${userid} | ${companyname}`;
                    if (employeeid && employeeName) {
                        displayValue += ` | ${employeeName}`;
                    }
                }

                return (
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <span style={{ marginRight: '5px', marginLeft: '10px' }}>
                            {displayValue}
                        </span>
                        {params.colDef.editable && <EditIcon style={{ marginLeft: 3, marginBottom: 3, fontSize: '1rem' }} />}
                    </div>
                );
            },
            renderEditCell: (params) => {
                return (
                    <>
                        <Autocomplete
                            inputValue={companyInputValue}
                            onChange={(e, newValue) => {
                                handleCompanyChange(e, newValue, params.row.consigneeid)
                            }}
                            onInputChange={(event, newInputValue) => {
                                setCompanyInputValue(newInputValue);
                            }}
                            options={filteredCompanyOptions}
                            getOptionLabel={(option) => option.label || ''}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    variant="standard"
                                    autoFocus
                                />
                            )}
                            fullWidth
                            disableClearable
                            autoHighlight
                            openOnFocus
                            open={open}
                            onOpen={() => setOpen(true)}
                            onClose={() => setOpen(false)}
                            ListboxComponent={(listboxProps) => (
                                <ul
                                    {...listboxProps}
                                    style={{
                                        padding: 0,
                                        margin: 0,
                                        maxHeight: '300px',
                                        overflowY: 'auto'
                                    }}
                                >
                                    <li
                                        style={{
                                            position: 'sticky',
                                            top: 0,
                                            backgroundColor: 'white',
                                            zIndex: 1,
                                            borderBottom: '1px solid #ddd'
                                        }}
                                    >
                                        <div
                                            onClick={() => handleButtonClick(params.row.consigneeid, params.row.consigneename, "company")}
                                            style={{
                                                cursor: 'pointer',
                                                color: 'blue',
                                                display: 'flex',
                                                alignItems: 'center',
                                                padding: '8px',
                                                backgroundColor: '#d3d3d3'
                                            }}
                                        >
                                            <SvgIcon component={AddIcon} style={{ marginRight: 8 }} />
                                            Add User
                                        </div>
                                    </li>
                                    {listboxProps.children}
                                </ul>
                            )}
                        // isOptionEqualToValue={(option, value) => option.id === value.id}
                        />
                    </>
                );
            },
            cellClassName: (params) => 'lavenderCell',
        },
        {
            field: "user",
            headerName: "MAPPED TO USER",
            headerAlign: "center",
            align: "center",
            width: 350,
            editable: true,
            renderCell: (params) => {
                const username = params.row.mappedtouser != null ? params.row.mappedtouser : '';
                const userid = params.row.mappedtoid ? params.row.mappedtoid : '';
                const userData = userMap[userid];
                const employeeid = userData ? userData[1] : '';
                const employeeName = userData ? userData[2] : '';

                let displayValue = '';

                if (userid && username) {
                    displayValue = `${userid} | ${username}`;
                    if (employeeid && employeeName) {
                        displayValue += ` | ${employeeName}`;
                    }
                }
                return (
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <span style={{ marginRight: '5px', marginLeft: '10px' }}>
                            {displayValue}
                        </span>
                        {params.colDef.editable && <EditIcon style={{ marginLeft: 3, marginBottom: 3, fontSize: '1rem' }} />}
                    </div>
                );
            },
            renderEditCell: (params) => {
                return (
                    <>
                        <Autocomplete
                            inputValue={userInputValue}
                            onChange={(e, newValue) => {
                                handleUserChange(e, newValue, params.row.consigneeid)
                            }}
                            onInputChange={(event, newInputValue) => {
                                setUserInputValue(newInputValue);
                            }}
                            options={filteredUserOptions}
                            getOptionLabel={(option) => option.label || ''}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    variant="standard"
                                    autoFocus
                                />
                            )}
                            fullWidth
                            disableClearable
                            autoHighlight
                            openOnFocus
                            open={open}
                            onOpen={() => setOpen(true)}
                            onClose={() => setOpen(false)}
                            ListboxComponent={(listboxProps) => (
                                <ul
                                    {...listboxProps}
                                    style={{
                                        padding: 0,
                                        margin: 0,
                                        maxHeight: '300px',
                                        overflowY: 'auto'
                                    }}
                                >
                                    <li
                                        style={{
                                            position: 'sticky',
                                            top: 0,
                                            backgroundColor: 'white',
                                            zIndex: 1,
                                            borderBottom: '1px solid #ddd',
                                        }}
                                    >
                                        <div
                                            onClick={() => handleButtonClick(params.row.consigneeid, params.row.consigneename, "user")}
                                            style={{
                                                cursor: 'pointer',
                                                color: 'blue',
                                                display: 'flex',
                                                alignItems: 'center',
                                                padding: '8px',
                                                backgroundColor: '#d3d3d3'
                                            }}
                                        >
                                            <SvgIcon component={AddIcon} style={{ marginRight: 8 }} />
                                            Add User
                                        </div>
                                    </li>
                                    {listboxProps.children}
                                </ul>
                            )}
                        // isOptionEqualToValue={(option, value) => option.id === value.id}
                        />
                    </>
                );
            },
            cellClassName: (params) => 'lavenderCell',
        },
        {
            field: "mappedtoemployee",
            headerName: "MAPPED TO EMPLOYEE",
            headerAlign: "center",
            align: "center",
            width: 180,
            type: "singleSelect",
            valueOptions: filterValues ? filterValues.mappedtoemployee : [],
            filterOperators: Utility.combinedFilters(),
            renderCell: renderCellExpand,
        },
        {
            field: "mappedtoemployeeid",
            headerName: "MAPPED TO EMPLOYEEID",
            headerAlign: "center",
            align: "center",
            type: "number",
            valueFormatter: (params) => params.value,
            width: 80,
            renderCell: renderCellExpand,
        },
        {
            field: "marketsellstonecount",
            headerName: "N MKT SELL COUNT",
            headerAlign: "center",
            align: "center",
            type: "number",
            valueFormatter: (params) => params.value,
            width: 120,
            cellClassName: 'greenCell',
            renderHeader: () => (
                <Tooltip title="Count of Natural Stones from Wolza" placement="bottom">
                    <span>N MKT SELL COUNT</span>
                </Tooltip>
            ),
            renderCell: (params) => {

                const isClickable = params.value !== 0 && params.value !== null;

                return (<Button
                    sx={{
                        textDecorationLine: isClickable ? "underline" : "none",
                        color: "black",
                        textTransform: "none",
                        cursor: isClickable ? "pointer" : "default",
                    }}
                    onClick={isClickable ? () => handleWolzaDetail(params, "N") : undefined}
                >
                    {isClickable ? params.value : ""}
                </Button>)
            }
        },
        {
            field: "sumofestimatedfob",
            headerName: "N SUM OF FOB",
            headerAlign: "center",
            align: "center",
            width: 120,
            type: "number",
            cellClassName: 'greenCell',
            renderHeader: () => (
                <Tooltip title="Sum of Estimated FOB Value for Natural Stones from Wolza" placement="bottom">
                    <span>N SUM OF FOB</span>
                </Tooltip>
            ),
            valueFormatter: (params) => params.value,
            renderCell: renderCellExpand,
        },
        {
            field: "stonecount",
            headerName: "N STONE COUNT",
            headerAlign: "center",
            align: "center",
            minWidth: 120,
            flex: 1,
            type: "number",
            renderHeader: () => (
                <Tooltip title="Total Number of Available Natural Stones for Proposal to the Customer" placement="bottom">
                    <span>N STONE COUNT</span>
                </Tooltip>
            ),
            cellClassName: 'greenCell',
            valueFormatter: (params) => params.value,
            renderCell: renderCellExpand,
        },
        {
            field: "totalprice",
            headerName: "N TOTAL PRICE",
            headerAlign: "center",
            align: "center",
            minWidth: 90,
            flex: 1,
            type: "number",
            renderHeader: () => (
                <Tooltip title="Total Price of Available Natural Stones for Customer Proposal" placement="bottom">
                    <span>N TOTAL PRICE</span>
                </Tooltip>
            ),
            cellClassName: 'greenCell',
            valueFormatter: (params) => params.value,
            renderCell: renderCellExpand,
        },
        {
            field: "lg_marketsellstonecount",
            headerName: "LG MKT SELL COUNT",
            headerAlign: "center",
            align: "center",
            type: "number",
            valueFormatter: (params) => params.value,
            width: 120,
            cellClassName: 'brownCell',
            renderHeader: () => (
                <Tooltip title="Count of Lab Grown Stones from Wolza" placement="bottom">
                    <span>LG MKT SELL COUNT</span>
                </Tooltip>
            ),
            renderCell: (params) => {

                const isClickable = params.value !== 0 && params.value !== null;

                return (<Button
                    sx={{
                        textDecorationLine: isClickable ? "underline" : "none",
                        color: "black",
                        textTransform: "none",
                        cursor: isClickable ? "pointer" : "default",
                    }}
                    onClick={isClickable ? () => handleWolzaDetail(params, "LG") : undefined}
                    disabled={!isClickable}
                >
                    {isClickable ? params.value : ""}
                </Button>
                )
            }
        },
        {
            field: "lg_sumofestimatedfob",
            headerName: "LG SUM OF FOB",
            headerAlign: "center",
            align: "center",
            width: 120,
            type: "number",
            cellClassName: 'brownCell',
            renderHeader: () => (
                <Tooltip title="Sum of Estimated FOB Value for Lab Grown Stones from Wolza" placement="bottom">
                    <span>LG SUM OF FOB</span>
                </Tooltip>
            ),
            valueFormatter: (params) => params.value,
            renderCell: renderCellExpand,
        },
        {
            field: "lg_stonecount",
            headerName: "LG STONE COUNT",
            headerAlign: "center",
            align: "center",
            minWidth: 120,
            flex: 1,
            type: "number",
            cellClassName: 'brownCell',
            renderHeader: () => (
                <Tooltip title="Total Number of Available Lab Grown Stones for Proposal to the Customer" placement="bottom">
                    <span>LG STONE COUNT</span>
                </Tooltip>
            ),
            valueFormatter: (params) => params.value,
            renderCell: renderCellExpand,
        },
        {
            field: "lg_totalprice",
            headerName: "LG TOTAL PRICE",
            headerAlign: "center",
            align: "center",
            minWidth: 90,
            flex: 1,
            type: "number",
            cellClassName: 'brownCell',
            renderHeader: () => (
                <Tooltip title="Total Price of Available Lab Grown Stones for Customer Proposal" placement="bottom">
                    <span>LG TOTAL PRICE</span>
                </Tooltip>
            ),
            valueFormatter: (params) => params.value,
            renderCell: renderCellExpand,
        },
        {
            field: "updatedbyid",
            headerName: "UPDATED BY ID",
            headerAlign: "center",
            align: "center",
            width: 80,
            type: "number",
            valueFormatter: (params) => params.value,
            renderCell: renderCellExpand,
        },
        {
            field: "updatedbycompany",
            headerName: "UPDATED BY COMPANY",
            headerAlign: "center",
            align: "center",
            width: 200,
            type: "singleSelect",
            valueOptions: filterValues ? filterValues.updatedbycompany : [],
            filterOperators: Utility.combinedFilters(),
            renderCell: renderCellExpand,
        },
        {
            field: "updatedbyuser",
            headerName: "UPDATED BY USER",
            headerAlign: "center",
            align: "center",
            width: 150,
            type: "singleSelect",
            valueOptions: filterValues ? filterValues.updatedbyuser : [],
            filterOperators: Utility.combinedFilters(),
            valueGetter: (params) => {
                const { updatedbyid, updatedbyuser } = params.row;
                return updatedbyid && updatedbyuser ? `${updatedbyid} | ${updatedbyuser}` : '';
            },
            renderCell: (params) => {
                const { updatedbyid, updatedbyuser } = params.row;
                return updatedbyid && updatedbyuser ? `${updatedbyid} | ${updatedbyuser}` : '';
            },
        },
        {
            field: "link",
            headerName: "POTENTIAL SELL",
            headerAlign: "center",
            align: "center",
            export: false,
            width: 150,
            renderCell: (params) => {
                const rowData = params.row;
                const warningCondition = rowData.nullcertificatecount === null || rowData.marketsellstonecount === null || rowData.nullcertificatecount === rowData.marketsellstonecount;

                return (
                    <Box display="flex" justifyContent="center" alignItems="center">
                        {!warningCondition && (
                            <>
                                <Tooltip title="Open Link">
                                    <IconButton
                                        onClick={async (event) => {

                                            try {
                                                const link = rowData.link === "" ? await generateLink(rowData, "N") : rowData.link;
                                                openLinkInNewTab(link);
                                            } catch (error) {
                                                setShowSnackbar(true);
                                                setSnackBarMessage("Failed to generate link");
                                                setSnackBarVariant("error");
                                                setSnackBarTitle("Error");
                                            }

                                        }}
                                    >
                                        <OpenInNewIcon />
                                    </IconButton>
                                </Tooltip>

                                <Tooltip title="Copy Link">
                                    <IconButton
                                        onClick={async (event) => {
                                            try {
                                                const link = rowData.link === "" ? await generateLink(rowData, "N") : rowData.link;
                                                navigator.clipboard.writeText(link)
                                                    .then(() => {
                                                        setShowSnackbar(true);
                                                        setSnackBarMessage("Link Copied");
                                                        setSnackBarVariant("success");
                                                        setSnackBarTitle("Success");
                                                    })
                                                    .catch(err => {
                                                        console.error("Failed to copy link: ", err);
                                                    });
                                            } catch (error) {
                                                setShowSnackbar(true);
                                                setSnackBarMessage("Failed to copy link");
                                                setSnackBarVariant("error");
                                                setSnackBarTitle("Error");
                                            }
                                        }}
                                    >
                                        <FileCopyRoundedIcon />
                                    </IconButton>
                                </Tooltip>
                            </>
                        )}
                    </Box>
                );
            },
        },
    ]

    const columns = initialColumns();
    const CustomToolbar = () => {
        return (
            <GridToolbarContainer
                sx={{
                    display: "flex",
                    alignItems: "center",
                    marginHorizontal: "5px",
                    "&.MuiDataGrid-toolbarContainer": {
                        padding: "0px 4px !important",
                    },
                }}
            >
                <GridToolbarColumnsButton />
                <GridToolbarFilterButton />
                <GridToolbarExport />
                <Box sx={{ flexGrow: 1, display: { sm: "none", md: "block" } }} />
                {consigneeListLoader ? (
                    <CircularProgress size="1rem" />
                ) : (
                    <Tooltip title="Reload List">
                        <RefreshOutlinedIcon
                            color="primary"
                            fontSize="medium"
                            onClick={() => fetchConsigneeData(true)}
                            sx={{ cursor: "pointer" }}
                        />
                    </Tooltip>
                )}
                <GridToolbarQuickFilter debounceMs={500} />
            </GridToolbarContainer>
        );
    }

    return (
        <Box>
            <CommonSnackbar
                show={errorSnackbar}
                message={Constants.APiFailErrorMessage}
                variant={"error"}
                autoHide={Constants.SnackBarCloseTimer}
                title={"Failed"}
                handleClose={() => setErrorSnackbar(false)}
            />
            {
                access ? <NoPermission /> : (
                    <Box px={1} mt={4}>
                        {showSnackbar ? (
                            <TabMenuSnackbar
                                show={showSnackbar}
                                message={snackBarMessage}
                                variant={snackBarVariant}
                                autoHide={false}
                                title={snackBarTitle}
                                handleClose={() => { setShowSnackbar(false); }}
                            />)
                            : null}
                        {showWolzaDetailModal ? (
                            <Modal
                                enforceFocus={false}
                                show={showWolzaDetailModal}
                                onHide={() => setShowWolzaDetailModal(false)}
                                dialogClassName="max-modalSize"
                                style={{ zIndex: 1050 }}
                            >
                                <Modal.Header closeButton>
                                    <Modal.Title>
                                        <img
                                            src={logo}
                                            height="40pt"
                                            width="40pt"
                                            alt={Constants.COMPANY_SITE}
                                        />
                                        &nbsp;&nbsp;
                                        Wolza Details
                                    </Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    <MarketSellWolzaModal
                                        loadedCustomers={slectedCustomer}
                                        stone={null}
                                        fromDate={null}
                                        toDate={null}
                                        mappingkey={"withoutMapping"}
                                        stoneType={stonetype}
                                    />
                                </Modal.Body>
                            </Modal>
                        ) : null}
                        <Box
                            sx={{
                                backgroundColor: '#fff',
                                color: '#000',
                                width: "100%",
                                position: "relative",
                                "& .MuiTablePagination-selectLabel": {
                                    marginTop: "15px",
                                },
                                "& .MuiTablePagination-displayedRows": {
                                    marginTop: "15px",
                                },
                                "& .css-1jbbcbn-MuiDataGrid-columnHeaderTitle": {
                                    fontWeight: Constants.defaultFontWeight,
                                },
                                "& .css-cc8tf1": {
                                    fontWeight: Constants.defaultFontWeight,
                                },
                                "& .lavenderCell": {
                                    color: "#080808",
                                    backgroundColor: "#D8BFD8",
                                },
                                "& .greenCell": {
                                    color: "#080808",
                                    backgroundColor: "#C6DCBA",
                                },
                                "& .brownCell": {
                                    color: "#080808",
                                    backgroundColor: "#ebbdaa",
                                },
                                height: "85vh",
                            }}
                        >
                            <DataGridPro
                                disableRowSelectionOnClick={true}
                                density="compact"
                                loading={consigneeListLoader}
                                sx={{
                                    '& .MuiDataGrid-columnHeader': {
                                        color: '#fff',
                                        backgroundColor: 'grey',
                                    },
                                    "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": {
                                        py: "4px",
                                    },
                                    "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": {
                                        py: "12px",
                                    },
                                    "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": {
                                        py: "18px",
                                    },
                                    fontSize: Constants.defaultTableFontSize, fontWeight: Constants.defaultFontWeight,
                                }}
                                slots={{ toolbar: CustomToolbar }}
                                rows={consigneeList}
                                columns={columns}
                                checkboxSelection={true}
                                getRowId={(row) => row.consigneeid}
                                rowSelectionModel={selectionModel}
                                onRowSelectionModelChange={(newSelectionModel) => {
                                    setSelectionModel(newSelectionModel);
                                }}
                                initialState={{
                                    columns: {
                                        columnVisibilityModel: {
                                            // Hide columns status and traderName, the other columns will remain visible
                                            consigneeid: false,
                                            mappedtoid: false,
                                            updatedbyid: false,
                                            updatedbycompany: false,
                                            mappedtoemployeeid: false,
                                            link: false,
                                        },
                                    },
                                    pagination: {
                                        paginationModel: Constants.pageSize,
                                    },
                                }}
                                pageSizeOptions={Constants.pageSizeOptions}
                                pagination
                                slotProps={{
                                    toolbar: {
                                        showQuickFilter: true,
                                        quickFilterProps: { debounceMs: 500 },
                                    },
                                }}
                            />
                        </Box>
                    </Box>
                )}
        </Box>

    )
}
export default CreateMapping;